import React from 'react';
import '../Styles/Sponcer.css';

const Sponcer = () => {
  return (
    <div className="Sponcer-container">
      <h2 className="Sponcer-heading">Powered By</h2>
      <div className="Sponcer-marquee-wrapper">
        <div className="Sponcer-marquee">
          <div className="Sponcer-track">
            <span className="Sponcer-name">SN Ramesh & CH Ramesh <br/> (Principal Architects, R Square)</span>
            <span className="Sponcer-name">Ravindra Reddy <br/> ( Liv In Green Projects)</span>
            <span className="Sponcer-name">Sachin <br/> (Possible Machines)</span>
            <span className="Sponcer-name">Kodanda Ram <br/> (Architect Design Ace)</span>
            <span className="Sponcer-name">V.K Ashok Kumar <br/> (VKB Earth Movers)</span>
            <span className="Sponcer-name">Dayaram Patel <br/>(HD Doors)</span>
            <span className="Sponcer-name">Kishore S Patel & Praveen S Patel <br/>(Ashok Timber Trading Company)</span>
            <span className="Sponcer-name">Chethan <br/>(Ashwa Surveys)</span>

            {/* 🔁 Duplicate for seamless scroll */}
            <span className="Sponcer-name">SN Ramesh & CH Ramesh <br/> (Principal Architects, R Square)</span>
            <span className="Sponcer-name">Ravindra Reddy <br/> ( Liv In Green Projects)</span>
            <span className="Sponcer-name">Sachin <br/> (Possible Machines)</span>
            <span className="Sponcer-name">Kodanda Ram <br/> (Architect Design Ace)</span>
            <span className="Sponcer-name">V.K Ashok Kumar <br/> (VKB Earth Movers)</span>
            <span className="Sponcer-name">Dayaram Patel <br/>(HD Doors)</span>
            <span className="Sponcer-name">Kishore S Patel & Praveen S Patel <br/>(Ashok Timber Trading Company)</span>
            <span className="Sponcer-name">Chethan <br/>(Ashwa Surveys)</span>
            {/* <span className="Sponcer-name">SN Ramesh & CH Ramesh</span>
            <span className="Sponcer-name">Ravindra Reddy</span>
            <span className="Sponcer-name">Sachin (Possible Machines)</span>
            <span className="Sponcer-name">Kodanda Ram & Bharathi</span>
            <span className="Sponcer-name">V.K Ashok Kumar (VKB Earth Movers)</span>
            <span className="Sponcer-name">Dayaram Patel, Lalji Patel, Kishore Patel & Praveen Patel</span> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sponcer;
